import {isMobile} from 'mobile-device-detect';
const { detect } = require('detect-browser');
const browser = detect();


const isBadBrowser = () => {
    return (browser.name === "safari" || isMobile);
}

export {isBadBrowser}